import React from 'react';
import './Default.css';
import { Link } from 'react-router-dom';

function Info() {
    return (
      <>
        <div className="page-title">
          Informacje
        </div>
        <div className='boxes-contener'>
            <div className='text-box'>
              <div className='text-box-header'>Wersja</div>
              1.3.2
            </div>
            <div className='text-box'>
              <div className='text-box-header'>Kontakt</div>
              annakrasodomska@zhr.pl
            </div>
            <div className='text-box'>
              <div className='text-box-header'>Polityka prywatności</div>
              <Link to="/privacy-policy">Kliknij aby przeczytać</Link>
            </div>
            <div className='text-box'>
              <div className='text-box-header'>Programiści</div>
              Anna Krasodomska <br/>
              Tadeusz Brzeski <br/>
              Łukasz Głazik <br/>
              Tomasz Szcząchor
            </div>
            <div className='text-box'>
              <div className='text-box-header'>Pomoc programistyczna</div>
              Mateusz Nowak
            </div>
            <div className='text-box'>
              <div className='text-box-header'>Teksty</div>
              Gosia Galińska <br/>
              Zofia Urmańska <br/>
              Amelia Paw <br/>
              Zuzanna Sekta <br/>
              Kornelia Wojewódzka
            </div>
        </div>
      </>
    );
}

export default Info;